/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single scraped property content item (media from hotel chain websites)
 * @export
 * @interface ScrapedPropertyContentItem
 */
export interface ScrapedPropertyContentItem {
    /**
     * 
     * @type {number}
     * @memberof ScrapedPropertyContentItem
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    chainName: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    mediaLink: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    mediaName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    mediaCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    mediaDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedPropertyContentItem
     */
    mediaContentType: ScrapedPropertyContentItemMediaContentTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ScrapedPropertyContentItem
     */
    additionalDetails?: object;
}


/**
 * @export
 */
export const ScrapedPropertyContentItemMediaContentTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO'
} as const;
export type ScrapedPropertyContentItemMediaContentTypeEnum = typeof ScrapedPropertyContentItemMediaContentTypeEnum[keyof typeof ScrapedPropertyContentItemMediaContentTypeEnum];


/**
 * Check if a given object implements the ScrapedPropertyContentItem interface.
 */
export function instanceOfScrapedPropertyContentItem(value: object): value is ScrapedPropertyContentItem {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('chainName' in value) || value['chainName'] === undefined) return false;
    if (!('supplierId' in value) || value['supplierId'] === undefined) return false;
    if (!('mediaLink' in value) || value['mediaLink'] === undefined) return false;
    if (!('mediaContentType' in value) || value['mediaContentType'] === undefined) return false;
    return true;
}

export function ScrapedPropertyContentItemFromJSON(json: any): ScrapedPropertyContentItem {
    return ScrapedPropertyContentItemFromJSONTyped(json, false);
}

export function ScrapedPropertyContentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapedPropertyContentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'chainName': json['chain_name'],
        'supplierId': json['supplier_id'],
        'mediaLink': json['media_link'],
        'mediaName': json['media_name'] == null ? undefined : json['media_name'],
        'mediaCategory': json['media_category'] == null ? undefined : json['media_category'],
        'mediaDescription': json['media_description'] == null ? undefined : json['media_description'],
        'mediaContentType': json['media_content_type'],
        'additionalDetails': json['additional_details'] == null ? undefined : json['additional_details'],
    };
}

export function ScrapedPropertyContentItemToJSON(json: any): ScrapedPropertyContentItem {
    return ScrapedPropertyContentItemToJSONTyped(json, false);
}

export function ScrapedPropertyContentItemToJSONTyped(value?: ScrapedPropertyContentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'chain_name': value['chainName'],
        'supplier_id': value['supplierId'],
        'media_link': value['mediaLink'],
        'media_name': value['mediaName'],
        'media_category': value['mediaCategory'],
        'media_description': value['mediaDescription'],
        'media_content_type': value['mediaContentType'],
        'additional_details': value['additionalDetails'],
    };
}

